export const datasetTypeMap = {
  db: 'deDataset.database',
  sql: 'SQL',
  excel: 'EXCEL',
  union: 'dataset.union',
  api: 'API'
}
